module.exports = "/images/vendor/blueimp-gallery/video-play.png?f2127deda35d057e7cce847d87fef830";